import { Token } from '../define/token';

export function isImageOnly(token: Token): boolean {
  return 'tokens' in token && token.tokens?.length === 1 && token.tokens[0]!.type === 'image';
}

export function hasImage(token: Token): boolean {
  if (token.type === 'image') return true;

  if ('tokens' in token && token.tokens?.length) {
    return (token.tokens as Token[]).some(hasImage);
  }
  if (token.type === 'list' && token.items.length) {
    return token.items.some(hasImage);
  }

  return false;
}

export function getTextOfToken(token: Token): string {
  if ('tokens' in token && token.tokens) {
    return token.tokens.reduce((text, tk) => {
      return text + getTextOfToken(tk);
    }, '');
  }

  if (token.type !== 'text') return '';

  return token.text;
}
